import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid } from '@mui/material';
import ListadoVistas from './components/ListadoVistas';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { allVistasAction, setActivoVistasAction } from './VistasAction';
import FormVistas from './components/FormVistas';
import { ModalComponent } from '../../../widgets';

const VistasView = () => {
  const dispatch = Redux.useDispatch();

  const vistasStore = Redux.useSelector((state) => state.vistas);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoVistasAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          addIcon
          mr={2}
        />
        <BotonComponent
          click={async () => {
            await setActivoVistasAction(dispatch, null);
            await allVistasAction(dispatch, vistasStore.params);
          }}
          disabled={vistasStore.all.length === 0 || vistasStore.loadingAll}
          white
          refreshIcon
          text={vistasStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoVistas setOpenModalForm={(value) => setOpenModalForm(value)} />
      </Grid>
      <ModalComponent
        id="modalFormVistas"
        title={
          vistasStore.activo
            ? `Editar ${vistasStore.activo.nombre}`
            : 'Nueva vista del sistema'
        }
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormVistas
          activo={vistasStore.activo}
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default VistasView;
